module.exports = __webpack_public_path__ + "img/tv-24px.4d923999.svg";